import { useContext, useEffect, useState } from "react";
import { getRacesE } from "../../../../api/raceApi";
import { getPhasesE } from "../../../../api/phaseApi";
import { addAnimalE, getAnimalByIdE, getAnimalsE, updateAnimalE } from "../../../../api/animalsApi";
import { addReproductionE, getReproductionByAnimalE, updateReproductionE } from "../../../../api/reproductionApi";
import { getStatusE, getStatusByIdE, getStatusByNameE } from "../../../../api/statusApi";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../Contexts/AuthContext";
import { GiCow } from "react-icons/gi";
//import './editAnimal.css';
import swal from "sweetalert";

export const AdminAddEditAnimalEleveur = ({ edit = false }) => {
  const {user} = useContext(AuthContext);

  const [numero, setNumero] = useState('');
  const [nom, setNom] = useState('');
  const [dateNaissance, setDateNaissance] = useState('');
  const [phaseId, setPhaseId] = useState('');
  const [raceId, setRaceId] = useState('');
  const [poids, setPoids] = useState('');
  const [genre, setGenre] = useState('');
  const [animalId, setAnimalId] = useState('');
  const [motherId, setMotherId] = useState('');
  const [animals, setAnimals] = useState([]);
  const [statusId, setStatusId] = useState('');

  const [status, setStatus] = useState('');

  const [statuss, setStatuss] = useState([]);

  const [reprodId, setReprodId] = useState('');
  const [reprodDV, setReprodDV] = useState('');
  const [reprodDS, setReprodDS] = useState('');
  const [reprodDPV, setReprodDPV] = useState('');
  const [reprodDG, setReprodDG] = useState('');
  const [races, setRaces] = useState([]);
  const [phases, setPhases] = useState([]);
  const [error, setError] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const today = new Date();


  useEffect(() => {
    getRacesE().then(data => setRaces(data));
    getPhasesE().then(data => setPhases(data));
    getStatusE().then(data => setStatuss(data));
    getAnimalsE().then(data => setAnimals(data));
  }, []);

  useEffect(() => {
    if (!edit && id) {
      setMotherId(id);
    }
    if (edit && id) {
      getAnimalByIdE(id)
        .then(data => {
          setNumero(data.numero || '');
          setNom(data.nom || '');
          setDateNaissance(data.date_naissance || '');
          setPhaseId(data.phase_id || '');
          setRaceId(data.race_id || '');
          setPoids(data.poids || '');
          setGenre(data.genre || '');
          setAnimalId(data.id || '');
          setMotherId(data.mother_id || '');

        });

      getReproductionByAnimalE(id).then(
        data => {
          setReprodId(data.id);
          setReprodDV(data.date_velage || '');
          setReprodDS(data.date_saille || '');
          setReprodDPV(data.date_prevu_velage || '');
          setReprodDG(data.date_gestation || '');
          setStatusId(data.status_id);
          console.log(data.id);
          console.log(data.status_id);
          console.log(data.date_gestation);
          console.log(data);
        }
      )
    }
  }, [edit, id]);

  useEffect(() => {
    if (!statusId) return;
    getStatusByIdE(statusId).then(
      data => { setStatus(data.titre); }
    )
  }, [statusId])

  const validateForm = async () => {
    const birthDate = new Date(dateNaissance);
    const ageDays = (today - birthDate) / (1000 * 60 * 60 * 24);
    let statusName = null;
    try {
      const statusData = await getStatusByIdE(statusId);
      statusName = statusData.titre;
    } catch (err) {
      setError('Erreur lors de la récupération du status');
      return false;
    }

    if (statusName !== 'croissance') {
      if (ageDays < 365) {
        setError("Ne peut pas avoir ce status si l'animal a moins de 1 ans.");
        return false;
      }
      if (genre === 'male'){
        setError("Ne peut pas faire " + statusName +' a un animal male !');
        return false;
      }
    }

    if (statusName === 'croissance') {
      if (ageDays >= 730) {
        setError("Un animal de plus de 2 ans ne peut pas être en phase de croissance.");
        return false;
      }

      if (reprodDS || reprodDV || reprodDG) {
        setError('L\'animal est en croissance, ne peut pas avoir de données de reproduction.');
        return false;
      }
    }

    const filledDates = [reprodDV, reprodDS]
      .filter(date => date && date.trim() !== '');

    const uniqueDates = new Set(filledDates);

    if (filledDates.length > 0 && uniqueDates.size < filledDates.length) {
      setError('Les dates de reproduction ne peuvent pas être identiques.');
      return false;
    }

    if (statusName === "Gestation" || statusName === "Repos") {
      if (!reprodDG) {
        setError("date Gestation doit pas être vide !");
        return false;
      }
    }

    if (statusName === "Saillie" || statusName === "Oestrus") {
      if (!reprodDS) {
        setError("date Saillie doit pas être vide !");
        return false;
      }
    }

    if (statusName === "Vêlage") {
      if (!reprodDV) {
        setError("date Vêlage doit pas être vide !");
        return false;
      }
    }

    if (reprodDV && new Date(reprodDV) > today) {
      setError('Date Vêlage ne peut pas être dans le futur');
      return false;
    }

    if (reprodDS && new Date(reprodDS) > today) {
      setError('Date Saillie ne peut pas être dans le futur');
      return false;
    }

    if (reprodDG && new Date(reprodDG) > today) {
      setError('Date Gestation ne peut pas être dans le futur');
      return false;
    }

    setError('');
    return true;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const isValid = await validateForm();
    if (!isValid) return;
    const animalData = {
      numero,
      nom,
      date_naissance: dateNaissance,
      poids,
      genre,
      phase_id: phaseId,
      race_id: raceId,
      user_id: user.id,
      mother_id: motherId || null,
      ferme_id: user.ferme_id,
    };


    try {
      const dateV = reprodDV ? new Date(reprodDV) : null;
      const dateS = reprodDS ? new Date(reprodDS) : null;
      const dateG = reprodDG ? new Date(reprodDG) : null;
      let FStatus = statusId;
      if (reprodDG) {
        const diffDGt = today - dateG;
        const diffTGt = diffDGt / (1000 * 60 * 60 * 24);
        if (diffTGt <= 280 && diffTGt >= 1 && !FStatus) {
          const st = await getStatusByNameE('Gestation');
          FStatus = st.id
        } if ((diffTGt > 280 || diffTGt < 1) && !FStatus) {
          swal('status field is required', '', 'error');
          return;
        }
      }

      if (edit && id) {
        if (!reprodId) {
          console.log('error');
        }

        const reproductionDataU = {
          date_velage: reprodDV || null,
          date_saille: reprodDS || reprodDG || null,
          date_gestation: reprodDG || null,
          status_id: FStatus
        }

        if (reprodId) {
          await updateReproductionE(reprodId, reproductionDataU)
        } else {
          const reproductionData = {
            animalId: id,
            date_velage: reprodDV,
            date_saille: reprodDS || reprodDG,
            date_gestation: reprodDG,
            statusId: FStatus || statusId
          };
          console.log(reproductionData)
          await addReproductionE(reproductionData).then(data => console.log(data));
        }
        await updateAnimalE(id, animalData);

        navigate("/eleveur/animals");
        return;

      } else {

        const birthDate = new Date(dateNaissance);
        if (birthDate >= today) {
          swal("La date de naissance doit être avant aujourd'hui.", "", "error");
          return;
        }

        try {
          let statusName = null;

          const usedStatusId = FStatus || statusId;
          if (usedStatusId) {
            const statusData = await getStatusByIdE(usedStatusId);
            statusName = statusData.titre;
          }

          console.log("Current status:", statusName);

          const birthDate = new Date(dateNaissance);
          const ageDays = (today - birthDate) / (1000 * 60 * 60 * 24);

          const newAnimal = await addAnimalE(animalData);
          const animalId = newAnimal.id;

          if (statusName != 'croissance') {
            const reproductionData = {
              animalId,
              date_velage: reprodDV || null,
              date_saille: reprodDS || reprodDG || null,
              date_gestation: reprodDG || null,
              statusId: usedStatusId,
            };

            await addReproductionE(reproductionData);
          }else {
            const reproductionData = {
              animalId,
              statusId: usedStatusId,
            };

            await addReproductionE(reproductionData);
          }

          navigate("/eleveur/animals");

        } catch (err) {
          console.error("Error:", err.response?.data || err.message);
        }

      }
    } catch (err) {
      console.error('Error:', err.response?.data || err.message);
    }

  }

  return (
    <div className="animal-form-container">
      <h2>{edit ? "Modifier" : "Ajouter"} un animal</h2>
      <form onSubmit={handleSubmit}>
        <div className="Add-animal-edit-div">
          <label className="required">Numéro:</label>
          <input type="text" value={numero} onChange={e => setNumero(e.target.value)} required />
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Nom:</label>
          <input type="text" value={nom} onChange={e => setNom(e.target.value)} required />
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Date de Naissance:</label>
          <input type="date" value={dateNaissance} onChange={e => setDateNaissance(e.target.value)} required />
        </div>
        <div className="Add-animal-edit-div">
          <label>Poids:</label>
          <input type="text" value={poids} onChange={e => setPoids(e.target.value)} />
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Genre:</label>
          <select value={genre} onChange={e => setGenre(e.target.value)} required>
            <option value="">Select Genre</option>
            <option value="male">Male</option>
            <option value="femelle">Femelle</option>
          </select>
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Phase:</label>
          <select value={phaseId} onChange={e => setPhaseId(e.target.value)} required>
            <option value="">Select Phase</option>
            {phases.map(phase => (
              <option key={phase.id} value={phase.id}>{phase.titre}</option>
            ))}
          </select>
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Race:</label>
          <select value={raceId} onChange={e => setRaceId(e.target.value)} required>
            <option value="">Select Race</option>
            {races.map(r => (
              <option key={r.id} value={r.id}>{r.nom}</option>
            ))}
          </select>
        </div>
        <div className="Add-animal-edit-div">
          <label className="mother">Mother:</label>
          <select value={motherId} onChange={e => setMotherId(e.target.value)}>
            <option value="">Select Mother</option>
            {animals.filter(a => !edit || a.id !== parseInt(id)).map(a => (
              <option key={a.id} value={a.id}>{a.numero} - {a.nom}</option>
            ))}
          </select>
        </div>
        

        <h3><GiCow className='cow'/> Informations de Reproduction</h3>
        {error && <h4 style={{ color: 'red' }}>{error}</h4>}
        <div className="Add-animal-edit-div">
          <label>Date Saillie:</label>
          <input type="date" value={reprodDS} onChange={e => setReprodDS(e.target.value)} />
        </div>
        <div className="Add-animal-edit-div">
          <label>Date Vêlage:</label>
          <input type="date" value={reprodDV} onChange={e => setReprodDV(e.target.value)} />
        </div>
        <div className="Add-animal-edit-div">
          <label>Date Gestation:</label>
          <input type="date" value={reprodDG} onChange={e => setReprodDG(e.target.value)} />
        </div>
        <div className="Add-animal-edit-div">
          <label className="required">Status Actuel :</label>
          <select value={statusId} onChange={e => setStatusId(e.target.value)} required>
            <option value="">Select Status</option>
            {statuss.filter(s => s.titre !== 'Avortement').map(s => (
              <option key={s.id} value={s.id}>{s.titre}</option>
            ))}
          </select>
        </div>
        <button type="submit" className="update-add-button">
          {edit ? 'Update' : 'Add'} Animal
        </button>
      </form>
    </div>
  );
};
